import React, { useRef, useState } from "react";
import { Container, Grid } from "@mui/material";

import { SectionHeading, SectionWrapper } from "../../Styles/style";

import copy from "../../../assets/images/copy.png"

import { TWrapper, Name, Value, MainGrid, Textarea, ContractAdd } from "./styles";
import styled from "@emotion/styled";

const Index = () => {
  const [copySuccess, setCopySuccess] = useState("");
  const textAreaRef = useRef(null);

  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand("copy");
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    e.target.focus();
    setCopySuccess("Copied!");
  }
const CopyImg = styled.img`
  width:100%;
  max-width: 50px;
`
  return (
    <SectionWrapper p599="2rem 0px" p="4rem 0 2rem 0" id="tokenomics">
      <Container maxWidth="xl">
        <SectionHeading data-aos="zoom-in" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="500" data-aos-offset="0" >
          Tokenomics</SectionHeading>
        <MainGrid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TWrapper data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0">
              <Name>Supply</Name><Value>TBA</Value>
            </TWrapper>
          </Grid>
          <Grid item xs={12} md={6}>
            <TWrapper data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0">
              <Name>Taxes</Name><Value>TBA</Value>
            </TWrapper>
          </Grid>
          <Grid item xs={12} md={6}> <TWrapper><Name> Slippage</Name><Value>TBA</Value></TWrapper> </Grid>
          <Grid item xs={12} md={6}> <TWrapper><Name>Initial Liquidity</Name><Value>TBA</Value></TWrapper></Grid>
          <Grid item xs={12}>
            <TWrapper br="0 0px 0 0" p="0px 0px 0px 10px" bgimg="linear-gradient(#2D374B,#090f0d00)" data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0">
              <Name >Contract</Name>
              <div style={{ display: "flex", alignItems: "self-start" }} color="#FFF">
                <Textarea ref={textAreaRef} value="TBA" />
                <CopyImg onClick={copyToClipboard} style={{ cursor: "pointer" }} src={copy} />
                {/* {copySuccess} */}
              </div>
            </TWrapper>
          </Grid>
        </MainGrid>
      </Container>
    </SectionWrapper>
  );
};

export default Index;
